// extracted by mini-css-extract-plugin
export default {"container":"CalculatingIncidenceRate_container__nczr8","title":"CalculatingIncidenceRate_title__CdB7B","description":"CalculatingIncidenceRate_description__pjXqC"};